import api from 'api';
import type { AddOnCodes } from 'redux/modules/accounts.schema';
import type { RawAddOn } from 'types/account';
import { forceIntercomPing } from 'utils/intercom-helper';

export const AccountAddOnsAPI = {
  list(): Promise<Array<RawAddOn>> {
    return api.get('subscriptions/add_ons');
  },
  cancel: (code: AddOnCodes): Promise<RawAddOn> => {
    return api.delete('subscriptions/add_ons', { code });
  },
  subscribe: (code: AddOnCodes): Promise<RawAddOn> => {
    return api.post('subscriptions/add_ons', { code });
  },
  trial: (code: string): Promise<RawAddOn> => {
    return api.post('subscriptions/add_ons/trial', { code }).then(res => {
      // Ping intercom after a delay, to ensure the user inherits
      // new trial properties set on the workspace/"company",
      // used to trigger product tours
      forceIntercomPing(5);
      return res;
    });
  },
};
